var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "ctm-abandonment-settings" },
    [
      _vm.loading
        ? _c("div", { staticClass: "ctm-abandonment-settings__loading" }, [
            _c("i", { staticClass: "el-icon-loading" }),
            _vm._v(" Loading…\n    ")
          ])
        : [
            _vm._m(0),
            _vm._v(" "),
            _vm._m(1),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-abandonment-settings__section-title" },
              [
                _c("el-switch", {
                  model: {
                    value: _vm.settings.followup_enabled,
                    callback: function($$v) {
                      _vm.$set(_vm.settings, "followup_enabled", $$v)
                    },
                    expression: "settings.followup_enabled"
                  }
                }),
                _vm._v(" "),
                _c("span", [_vm._v("Enable follow-up emails")])
              ],
              1
            ),
            _vm._v(" "),
            _vm.settings.followup_enabled
              ? _c(
                  "el-form",
                  {
                    staticClass: "ctm-abandonment-settings__form",
                    attrs: { "label-position": "top" }
                  },
                  [
                    _c(
                      "el-form-item",
                      { attrs: { label: "Delay (minutes)" } },
                      [
                        _c("el-input-number", {
                          staticStyle: { width: "160px" },
                          attrs: { min: 1, max: 10080 },
                          model: {
                            value: _vm.settings.followup_delay,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "followup_delay", $$v)
                            },
                            expression: "settings.followup_delay"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ctm-abandonment-settings__help" },
                          [
                            _vm._v(
                              "\n                    How long to wait after abandonment before sending the email. Minimum 1 minute.\n                "
                            )
                          ]
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-row",
                      { attrs: { gutter: 16 } },
                      [
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "From Name" } },
                              [
                                _c("el-input", {
                                  attrs: { placeholder: "Your site name" },
                                  model: {
                                    value: _vm.settings.followup_from_name,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings,
                                        "followup_from_name",
                                        $$v
                                      )
                                    },
                                    expression: "settings.followup_from_name"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "el-col",
                          { attrs: { span: 12 } },
                          [
                            _c(
                              "el-form-item",
                              { attrs: { label: "From Email" } },
                              [
                                _c("el-input", {
                                  attrs: {
                                    placeholder: "noreply@yourdomain.com"
                                  },
                                  model: {
                                    value: _vm.settings.followup_from_email,
                                    callback: function($$v) {
                                      _vm.$set(
                                        _vm.settings,
                                        "followup_from_email",
                                        $$v
                                      )
                                    },
                                    expression: "settings.followup_from_email"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Subject" } },
                      [
                        _c("el-input", {
                          attrs: { placeholder: "Did you forget to finish?" },
                          model: {
                            value: _vm.settings.followup_subject,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "followup_subject", $$v)
                            },
                            expression: "settings.followup_subject"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "el-form-item",
                      { attrs: { label: "Message Body" } },
                      [
                        _c("el-input", {
                          attrs: {
                            type: "textarea",
                            rows: 6,
                            placeholder:
                              "Hi,&#10;&#10;You started filling out a form on our site but didn't finish…"
                          },
                          model: {
                            value: _vm.settings.followup_body,
                            callback: function($$v) {
                              _vm.$set(_vm.settings, "followup_body", $$v)
                            },
                            expression: "settings.followup_body"
                          }
                        }),
                        _vm._v(" "),
                        _c(
                          "p",
                          { staticClass: "ctm-abandonment-settings__help" },
                          [
                            _vm._v(
                              "\n                    Plain text. The email is sent only when the visitor provided an email address before leaving.\n                "
                            )
                          ]
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              : _vm._e(),
            _vm._v(" "),
            !_vm.settings.followup_enabled
              ? _c(
                  "div",
                  { staticClass: "ctm-abandonment-settings__disabled-note" },
                  [
                    _vm._v(
                      "\n            Follow-up emails are disabled. Tracking is still active — abandonment data will appear in Analytics.\n        "
                    )
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "ctm-abandonment-settings__actions" },
              [
                _c(
                  "el-button",
                  {
                    attrs: { type: "primary", loading: _vm.saving },
                    on: { click: _vm.save }
                  },
                  [_vm._v("Save Settings")]
                )
              ],
              1
            )
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-abandonment-settings__header" }, [
      _c("span", {
        staticClass:
          "ctm-abandonment-settings__icon dashicons dashicons-chart-line"
      }),
      _vm._v(" "),
      _c("div", [
        _c("h2", { staticClass: "ctm-abandonment-settings__title" }, [
          _vm._v("Form Abandonment Tracking")
        ]),
        _vm._v(" "),
        _c("p", { staticClass: "ctm-abandonment-settings__desc" }, [
          _vm._v(
            "\n                    Detects when a visitor starts filling a form but leaves without submitting.\n                    Abandonment events are recorded automatically — no configuration required for tracking.\n                    Enable follow-up emails below to re-engage users who provided their email address.\n                "
          )
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "ctm-abandonment-settings__info-box" }, [
      _c("p", { staticClass: "ctm-abandonment-settings__info-title" }, [
        _vm._v("How tracking works")
      ]),
      _vm._v(" "),
      _c("ul", { staticClass: "ctm-abandonment-settings__info-list" }, [
        _c("li", [
          _vm._v(
            "A JavaScript listener fires when the user interacts with any form field."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "If the user navigates away without submitting, the event is sent via "
          ),
          _c("code", [_vm._v("sendBeacon")]),
          _vm._v(".")
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v(
            "The email address is only captured (and stored) when follow-up emails are enabled."
          )
        ]),
        _vm._v(" "),
        _c("li", [
          _vm._v("Abandonment rate appears on the "),
          _c("strong", [_vm._v("Analytics")]),
          _vm._v(" dashboard.")
        ])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }